<script setup>
import { ref, defineProps } from 'vue';
import InfoBoxBottom from '@/components/cloudCounter/InfoBoxBottom.vue';
import vuedraggable from 'vuedraggable';

const props = defineProps({
    data: Array,
    setData: Function,
    infoBoxTitle: String,
    infoBoxVisible: Boolean,
    infoBoxCloseHandle: Function,
    methods: Object,
});
/*
    props.data : [
        {
            title: '第一順位',
            isEqual: false,     //均等的
            order:[             //同順位
                [{
                    "key": "name",
                    "name": "姓名",
                    "placeholder": "請填寫姓名",
                    "value": ""
                }],
            ]
        },
    ],
*/

const toChineseNumber = (n) => ((props.methods?.toChineseNumber) ? props.methods.toChineseNumber(n) : n);

const setOrderIndex = (n) => {
    if (props.methods?.setOrderIndex) {
        props.methods.setOrderIndex(n);
    }
}

const updateList = (ary) => {
    if (props.methods.updateList) {
        props.methods.updateList(ary);
    }
}


const dragging = ref(false);

// 原始的資料
const originalData = JSON.parse(JSON.stringify(props.data));

// 編輯用的資料
const draggableData = ref(originalData);

const addNewOrderItem = () => {
    draggableData.value.push({
        title: '第' + toChineseNumber(draggableData.value.length + 1) + '順位',
        isEqual: false,     // 均等的
        order: []           // 同順位
    });
}

const cancelChange = () => {
    draggableData.value = originalData;
    props.infoBoxCloseHandle();
};


const saveChange = () => {
    if (props.setData) {

        // 重新整理資料
        updateList(draggableData.value);
        setOrderIndex(0);

        props.setData(JSON.parse(JSON.stringify(draggableData.value)));
    }

    props.infoBoxCloseHandle();
};


function dragFinish(item) {
    // 被增加的項目
    if (item.added?.element) {
        item.added.element.fields.find(item => item.id === 'ratio').value = '1';
        item.added.element.apiData.proportionNumerator = '1';
    }

    // 被移除的項目
    // if (item.removed?.element) {
    // }

}

</script>

<template>

    <InfoBoxBottom v-show="infoBoxVisible" :boxTitle="infoBoxTitle" :closeHandle="cancelChange">
        <p class="pb-4">調整順位後需重新填寫受益人分配比例</p>

        <template v-if="draggableData.length > 0">
            <div :class="{ 'pt-6': i !== 0 }" v-for="(item, i) in draggableData">
                <!-- 第N順位 -->
                <div class="text-sm">{{ item.title }}</div>

                <vuedraggable :list="item.order" class="p-0 m-0 min-h-[56px] list-unstyled relative" tag="ul"
                    group="people" @start="dragging = true" @end="dragging = false" item-key="name" @change="dragFinish">

                    <template #header v-if="item.order?.length == 0">
                        <div class="pt-4 absolute text-sm text-[#AEAFB4]">若無受益人，確認後將移除此順位，由後至前遞補</div>
                    </template>

                    <template #item="{ element, index }">
                        <li class="border-b bg-white">
                            <div class="p-4 flex justify-between items-center">
                                <div class="font-bold">{{ element.fields.find(x => x.id === 'name').value || '受益人' +
                                    toChineseNumber(index + 1) }}</div>
                                <div class="">
                                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path d="M4 12H20M4 18H20M4 6H20" stroke="#0093C1" stroke-width="2"
                                            stroke-linecap="round" stroke-linejoin="round" />
                                    </svg>
                                </div>
                            </div>
                        </li>
                    </template>
                </vuedraggable>
            </div>

            <button class="block w-full py-6 text-center text-sm text-[#0093C1]" @click="addNewOrderItem">
                <span class="inline-block align-text-bottom">
                    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="8.5" cy="10.5" r="7" fill="#0093C1" />
                        <path d="M8.5 7.5V13.4999" stroke="white" stroke-width="1.33333" stroke-linecap="round"
                            stroke-linejoin="round" />
                        <path d="M11.5 10.5H5.50006" stroke="white" stroke-width="1.3" stroke-linecap="round"
                            stroke-linejoin="round" />
                    </svg>
                </span>新增第{{ toChineseNumber(draggableData.length + 1) }}順位
            </button>
        </template>
        <template v-else>
            <div class="text-[#AEAFB4] text-sm"> 目前沒有受益人</div>
        </template>

        <div class="pt-4">
            <button class="py-3 w-full text-center text-white bg-[#0093C1] rounded-md" @click="saveChange">確認</button>
        </div>

    </InfoBoxBottom>

</template>

<style scoped></style>
